<template>
    <div class="p-4 bg-gray-100 rounded shadow">

        <div v-if="items.length" class="grid grid-cols-12 gap-4 mb-2">
            <div class="grid grid-cols-12 gap-4 col-span-11">
                <strong class="col-span-1">{{ __('admin::labels.enabled') }}</strong>
                <strong class="col-span-5">{{ __('admin::labels.rest_url') }}</strong>
                <strong class="col-span-3">{{ __('admin::labels.rest_username') }}</strong>
                <strong class="col-span-3">{{ __('admin::labels.rest_password') }}</strong>
            </div>
        </div>
        <div v-else class="text-gray-500">{{ __('admin::labels.no_items_added') }}</div>

        <div v-for="(item, index) in items" :key="item.__key" class="grid grid-cols-12 gap-4 mb-2">
            <div class="grid grid-cols-12 flex gap-4 col-span-11">
                <Toggle v-model:checked="item.enabled" class="col-span-1" />
                <Input type="text" :required="true" :placeholder="__('admin::labels.rest_url')" v-model="item.rest_url" class="col-span-5" />
                <Input type="text" :required="true" :placeholder="__('admin::labels.rest_username')" v-model="item.rest_username" class="col-span-3" />
                <Input type="text" :required="true" :placeholder="__('admin::labels.rest_password')" v-model="item.rest_password" class="col-span-3" />
            </div>

            <button type="button" class="col-span-1 flex items-center justify-center bg-gray-500" @click="removeItem(index)">
                <XIcon class="w-5 h-5 text-white" />
            </button>
        </div>

        <button type="button" class="flex items-center mt-4 text-secondary focus:outline-none" @click="addItem">
            <PlusIcon class="inline-block w-4 h-4 mr-1" />
            {{ __('admin::labels.add') }}
        </button>

    </div>
</template>

<script>
import { PlusIcon, XIcon } from '@heroicons/vue/outline';
import Input from "@/Components/Input";
import { v4 as uuidv4 } from 'uuid';
import Toggle from "@/Components/Toggle";

export default {
    components: {
        Toggle,
        Input,
        PlusIcon,
        XIcon,
    },
    props: {
        modelValue: Array,
        weekDayOptions: Object,
    },
    data() {
        return {
            items: [],
        }
    },
    created() {
        const items = this.modelValue;

        items.forEach((item) => {
            item.__key = uuidv4();
        });

        this.items = items;
    },
    watch: {
        items: {
            handler: function (newValue) {
                this.$emit('update:modelValue', newValue);
            },
            deep: true,
        }
    },
    methods: {
        addItem() {
            const item = {
                __key: uuidv4(),
                enabled: true,
                rest_url: '',
                rest_username: '',
                rest_password: '',
            };

            this.items.push(item);
        },
        removeItem(index) {
            this.items.splice(index, 1);
        },
    },
}
</script>
